var quickViewCountry = document.querySelector("[data-quickview-location]");
var quickViewLanguage = document.documentElement.lang;
var quickviewContainer = document.querySelector("[data-quickview-container]");
var quickviewAddToCart = document.querySelector("[quickview-add-to-cart]");
var quickAddVariantsId = document.querySelectorAll("[data-quickadd-variant-id]");
var quickAddSelectedVariantId = document.querySelector("[data-quickadd-selected-variant-id]");

// infos to update
var quickAddCollections = document.querySelectorAll("[data-quickview-collection]"); // 2 élements, passer en All et iterate
var quickAddTitles = document.querySelectorAll("[data-quickview-title]"); // 2 élements, passer en All et iterate
var quickAddSubtitles = document.querySelectorAll("[data-quickview-subtitle]"); // 2 élements, passer en All et iterate
var quickAddDescriptions = document.querySelectorAll("[data-quickview-description]"); // 2 élements, passer en All et iterate
var quickAddImage = document.querySelector("[data-quickview-image]");
var quickAddUrl = document.querySelectorAll("[data-quickview-url]");
var quickAddVariantsLabel = document.querySelectorAll("[data-quickview-variant-label]");

// Close quickadd
var quickviewCloses = document.querySelectorAll("[data-quickview-close]");
quickviewCloses.forEach(quickviewClose => {
    quickviewClose.addEventListener("click", () => {
        quickviewContainer.classList.remove("active");
        document.querySelector(".quickview__product").classList.remove("active");
        document.body.style.overflowY = "auto";
        document.querySelector('#styleQuickview').remove();
        document.querySelector('#styleQuickview2').remove();
    })
})

// open quickadd and udpate informations
var quickViewProducts = document.querySelectorAll("[data-product-handle]");
quickViewProducts.forEach(quickViewProduct => {

    quickViewProduct.addEventListener("click", (event) => {

        event.preventDefault();
        var productHandle = quickViewProduct.dataset.productHandle;

        if (productHandle == undefined) return false;

        quickviewContainer.classList.add("active");
        document.body.style.overflowY = "hidden";

        getProductInformations(productHandle);

    });
})

// change current variant and current price
quickAddVariantsId.forEach(quickAddVariantId => {
    quickAddVariantId.addEventListener("click", () => {
        var currentVariant = quickAddVariantId.dataset.quickaddVariantId;
        var currentPrice = quickAddVariantId.dataset.quickaddVariantPrice;
        quickAddSelectedVariantId.value = currentVariant;
        document.querySelector("[data-quickview-price]").innerHTML = currentPrice;
    });
});


quickviewAddToCart.addEventListener("click", () => {
    quickviewAddToCart.disabled = true;
    var variantId = quickAddSelectedVariantId.value;

    let formData = {
        'items': [{
            'id': variantId,
            'quantity': 1
        }]
    };

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(response => {
            quickviewAddToCart.disabled = false;
            document.querySelector("[data-quickview-close]").click()
            return response.json();
        })
        .catch((error) => {
            quickviewAddToCart.disabled = false;
            document.querySelector("[data-quickview-close]").click()
            console.error('Error:', error);
        });
});


function getProductInformations(handle) {

    var country_code = quickViewCountry.value || "FR";
    const language = quickViewLanguage || "EN";
    const uppercase_language = language.toUpperCase();

    const STOREFRONT_ACCESS_TOKEN = '2a24f67b34400189f3a9435be74e4a00';
    const GRAPHQL_URL = 'https://bonparfumeurusa.myshopify.com/api/2023-07/graphql.json';

    const getProduct = `query @inContext(country: `+ country_code +`,language: `+ uppercase_language +`){
        productByHandle(handle: "` + handle + `") {
            id
            handle
            title
            variants(first:100) {
                edges {
                    node {
                        title
                        id
                        price  {
                            amount
                        }
                        availableForSale
                        selectedOptions {
                            name
                            value
                        }
                        variant_icon: metafield(namespace: "custom", key: "variant_icon") {
                            value
                            key
                        }
                        economie: metafield(namespace: "custom", key: "economie") {
                            value
                            key
                        }
                        color: metafield(namespace: "custom", key: "color") {
                            value
                            key
                        }
                    }
                }
            }
            product_collection: metafield(namespace: "section", key: "collection") {
                value
                key
            }
            product_title: metafield(namespace: "section", key: "title") {
                value
                key
            }
            product_subtitle: metafield(namespace: "section", key: "subtitle") {
                value
                key
            }
            product_description: metafield(namespace: "section", key: "description") {
                value
                key
            }
            product_color: metafield(namespace: "section", key: "color") {
                value
                key
            }
            images(first:1) {
                edges {
                    node {
                        originalSrc
                        altText
                    }
                }
            }
        }
    }`;

    const params = {
        query: getProduct,
        variables: {
            handle: handle
        }
    };

    const optionsQuery = {
        method: "post",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN
        },
        body: JSON.stringify(params)
    };

    fetch(GRAPHQL_URL, optionsQuery)
        .then(res => res.json())
        .then(products => {
            if (products.data == undefined) return false;
            var product = products.data.productByHandle;

            if (products == null) return false;

            var image = product.images.edges[0].node.originalSrc;
            var variants = product.variants.edges;


            quickAddUrl.forEach((url) => {
                url.href = "/products/" + handle;
            })

            quickAddImage.src = image;

            if (product.product_collection) {
                //quickAddCollection.innerHTML = product.product_collection.value;
                quickAddCollections.forEach((quickAddCollection)=>{quickAddCollection.innerHTML = product.product_collection.value;})
            }

            if (product.product_collection == null){
                quickAddCollections.forEach((quickAddCollection)=>{
                    quickAddCollection.classList.add('hidden')
                })
            }

            if (product.product_title) {
                //quickAddTitle.innerHTML = product.product_title.value;
                quickAddTitles.forEach((quickAddTitle)=>{quickAddTitle.innerHTML = product.product_title.value;})
            }

            if (product.product_subtitle) {
                //quickAddSubtitle.innerHTML = product.product_subtitle.value;
                quickAddSubtitles.forEach((quickAddSubtitle)=>{quickAddSubtitle.innerHTML = product.product_subtitle.value;})
            }

            if (product.product_description) {
                //quickAddDescription.innerHTML = product.product_description.value;
                quickAddDescriptions.forEach((quickAddDescription)=>{quickAddDescription.innerHTML = product.product_description.value;})
            }

            if (product.product_color) {
                var styleElem = quickviewContainer.appendChild(document.createElement("style"));
                styleElem.setAttribute("id", "styleQuickview");
                styleElem.innerHTML = ".product__product-subtitle--quickview:after {background-color: " + product.product_color.value + ";}";
                var styleElem2 = quickviewContainer.appendChild(document.createElement("style"));
                styleElem2.setAttribute("id", "styleQuickview2");
                styleElem2.innerHTML = ".product-form__label-save-quickview {background-color: " + product.product_color.value + ";}";
            }


            if (variants.length === 1){
                document.querySelector(".quickview__products-variants-container").classList.add('hidden');
            }

            variants.forEach((variant, index) => {
                var v = variant.node;
                var variantId = v.id.replace("gid://shopify/ProductVariant/", "");
                var variantPriceBefore = parseFloat(v.price.amount);
                if ((variantPriceBefore - Math.floor(variantPriceBefore)) !== 0) {
                    var variantPrice = Shopify.formatMoney(v.price.amount);
                } else {
                    var p = v.price.amount + "0";
                    var variantPrice = Shopify.formatMoney(p);
                }

                var variantIcon = v.variant_icon;
                var variantEconomie = v.economie;
                var variantColor = v.color;


                var currentVariant = document.querySelectorAll("[data-quickadd-variant-id]")[index];

                if (currentVariant == undefined) return false;

                currentVariant.dataset.quickaddVariantId = variantId;
                currentVariant.dataset.quickaddVariantPrice = variantPrice;
                quickAddVariantsLabel[index].innerHTML = v.title + " / " + variantPrice;

                if (variantIcon) {
                    currentVariant.querySelector('[data-quickview-variant-image]').src = variantIcon.value;
                }

                if (variantEconomie) {
                    if (Shopify.country == "US") {
                        var economie = variantEconomie.value.replace('€', '$');
                    } else if (Shopify.country == "GB") {
                        var economie = variantEconomie.value.replace('€', '£');
                    } else {
                        var economie = variantEconomie.value;
                    }
                    currentVariant.querySelector('[data-quickview-variant-save]').innerHTML = economie;
                    currentVariant.querySelector('[data-quickview-variant-save]').style.padding = "2px 7px 2px 7px";
                }

                if (variantColor) {
                    var styleElem = quickviewContainer.appendChild(document.createElement("style"));
                    styleElem.setAttribute("id", "styleQuickview");
                    styleElem.innerHTML = ".product__product-subtitle--quickview:after {background-color: " + variantColor.value + ";}";
                    var styleElem2 = quickviewContainer.appendChild(document.createElement("style"));
                    styleElem2.setAttribute("id", "styleQuickview2");
                    styleElem2.innerHTML = ".product-form__label-save-quickview {background-color: " + variantColor.value + ";}";
                }


            });

            if (document.querySelectorAll("[data-quickadd-variant-id]")[0]) {
                if (variants[0] == undefined) {
                    document.querySelectorAll("[data-quickadd-variant-id]")[0].classList.add("hide");
                } else {
                    document.querySelectorAll("[data-quickadd-variant-id]")[0].classList.remove("hide");
                }
            }

            if (document.querySelectorAll("[data-quickadd-variant-id]")[1]) {
                if (variants[1] == undefined) {
                    document.querySelectorAll("[data-quickadd-variant-id]")[1].classList.add("hide");
                } else {
                    document.querySelectorAll("[data-quickadd-variant-id]")[1].classList.remove("hide");
                }
            }

            if (document.querySelectorAll("[data-quickadd-variant-id]")[2]) {
                if (variants[2] == undefined) {
                    document.querySelectorAll("[data-quickadd-variant-id]")[2].classList.add("hide");
                } else {
                    document.querySelectorAll("[data-quickadd-variant-id]")[2].classList.remove("hide");
                }
            }

            var variantPrice = Shopify.formatMoney(variants[0].node.price);
            document.querySelector("[data-quickview-price]").innerHTML = variantPrice;
            document.querySelectorAll(".quickview__content .product-form__input label")[0].click();
            document.querySelector(".quickview__product").classList.add("active");
            // ccolor

        })
}


customElements.define(
    'quickview-trigger',
    class quickviewTrigger extends HTMLElement {
        constructor() {
            super();

            this.productHandle = this.dataset.productHandle;

            this.addEventListener('click', this.openQuickview.bind(this));
        }

        openQuickview() {
            if (this.productHandle == undefined) return false;

            quickviewContainer.classList.add("active");

            getProductInformations(this.productHandle);
        }

    },
);

customElements.define(
    'quiz-add-samples',
    class quizAddSamples extends HTMLElement {
        constructor() {
            super();

            this.samplesVariantsId = JSON.parse(this.dataset.samplesVariantsId);

            this.addEventListener('click', this.addToCart.bind(this));
        }

        async addToCart() {
            if (this.samplesVariantsId == undefined) return false;

            if (this.samplesVariantsId.length != 0) {
                var dataAdd = {};
                dataAdd.items = [];
                for (let index = 0; index < this.samplesVariantsId.length; index++) {
                    dataAdd.items.push(
                        {
                            'id': this.samplesVariantsId[index],
                            'quantity': 1,
                            'properties': {
                                '_is_quiz_sample': true
                            }
                        }
                    );
                }
                await this.addItems(dataAdd);
            }


        }

        async addItems(data) {
            const result = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify(data)
            }).then((response) => {
                return response.text();
            })
                .then(async function (state) {

                })
                .catch(() => {

                });
        }

    },
);